<tt-page *ngIf="!!get">
    <tt-page-heading *ngIf="!!get.heading" [ttModel]="get.heading"></tt-page-heading>
    <tt-divider class="flex-1" ttRememberId="prognosispurchaseoverviewhistory.dividers">
        <tt-divider-rows ttId="griddividers">
            <tt-divider-pane ttId="overview">
                <tt-divider-columns ttId="overviewdividers">
                    <tt-divider-pane ttId="filters" *ngIf="get.show_filters === '1'" ttSize="15">
                        <tt-card>
                            <tt-select
                                ttRememberId="prognosispurchaseoverviewhistory.businessco_no"
                                ttLabel="businessco_no"
                                [(ttModel)]="get.businessco_no"
                                (ttModelChange)="loadStockplaces(); readOverviewGrid()"
                                [ttData]="companies"
                                ttDataId="businessco_no"
                                ttDataName="company_name"
                                ttShowClearButton
                            ></tt-select>
                            <tt-select
                                ttRememberId="prognosispurchaseoverviewhistory.stockplace_id"
                                ttLabel="stockplace_id"
                                [(ttModel)]="get.stockplace_id"
                                (ttModelChange)="readOverviewGrid()"
                                [ttData]="stockplaces"
                                ttDataId="stockplace_id"
                                ttDataName="stockplace_name"
                                ttShowClearButton
                            ></tt-select>
                            <tt-search
                                ttRememberId="prognosispurchaseoverviewhistory.supplier_name"
                                ttLabel="supplier"
                                [(ttModel)]="get.supplier_name"
                                [ttSearch]="searchSupplier"
                                (ttOnSelected)="onSupplierSelected($event)"
                                (ttOnClear)="onSupplierSelected()"
                                ttShowClearButton
                            ></tt-search>
                        </tt-card>
                    </tt-divider-pane>
                    <tt-divider-pane ttId="overview.grid" ttSize="85">
                        <tt-toast *ngIf="!!get.warning_message" class="col-xs-12 p-2" style="max-width: 60rem" [ttTitle]="get.warning_message" ttTranslateTitle="false" ttType="warning"></tt-toast>
                        <tt-grid
                            *ngIf="!!overviewGrid"
                            (ttOnRead)="selectedRow = undefined"
                            (ttOnRebind)="selectedRow = undefined"
                            [(ttOptions)]="overviewGrid"
                            ttRowSelection="single"
                            (ttOnRowSelected)="onPrognosisSelected($event)"
                            (ttReady)="onOverviewGridReady()"
                        ></tt-grid>
                    </tt-divider-pane>
                </tt-divider-columns>
            </tt-divider-pane>
            <tt-divider-pane ttId="details">
                <div class="flex-column height-full">
                    <tt-tabs ttRememberId="prognosispurchaseoverviewhistory.detail_tab" [(ttSelectedId)]="get.detail_tab">
                        <tt-tab ttId="details" ttLabel="details"></tt-tab>
                        <tt-tab ttId="log" ttLabel="prognosispurchaseoverviewhistory_log"></tt-tab>
                    </tt-tabs>
                    <tt-grid *ngIf="!!detailGrid && !!selectedRow" class="flex-1" [hidden]="get.detail_tab !== 'details'" [(ttOptions)]="detailGrid"></tt-grid>
                    <tt-grid *ngIf="!!logGrid && !!selectedRow" class="flex-1" [hidden]="get.detail_tab !== 'log'" [(ttOptions)]="logGrid"></tt-grid>
                </div>
            </tt-divider-pane>
        </tt-divider-rows>
    </tt-divider>
</tt-page>
